const NotFound = () => {
    return ( <>
   <div className="text-center">404 not found!</div> 
    </> );
}
 
export default NotFound;